<h1>Hair Removal Details <button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button>
</h1>
<div class="row" *ngIf="!dataLoaded"><i class="fa fa-spin fa-spinner"></i></div>
<div class="row" *ngIf="dataLoaded">
    <div class="col-sm-8 border-right">
        <form [formGroup]="hairRemovalForm" (submit)="submitForm()">
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Patient Name *</label>
                        <input type="text" formControlName="patient_name" class="form-control" readonly="readonly" />
                        <div *ngIf="submitted && f.patient_name.errors" class="invalid-feedback">
                            <div *ngIf="f.patient_name.errors.required">Patient Name is required</div>
                        </div>
                        <div *ngIf="(f.patient_name.value=='NA' || f.patient_name.value=='N/A') && invalidName"
                            class="invalid-feedback">
                            <div>Please enter valid name</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Patient Mobile *</label>
                        <input type="text" class="form-control" readonly="readonly" value="XXXXXXXXXX" />
                        <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">
                            <div *ngIf="f.mobile.errors.required">Patient Mobile is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Patient Age*</label>
                        <input type="number" formControlName="patient_age" class="form-control" />
                        <div *ngIf="submitted && f.patient_age.errors" class="invalid-feedback">
                            <div *ngIf="f.patient_age.errors.required">Age is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Gender*</label>
                        <mat-select placeholder="Gender" formControlName="gender">
                            <mat-option value="Male">Male</mat-option>
                            <mat-option value="Female">Female</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.gender.errors" class="invalid-feedback">
                            <div *ngIf="f.gender.errors.required">Gender is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Select BD *</label>
                        <mat-select placeholder="Select BD" [ngClass]="{'readOnly':myrole!='1'}"
                            formControlName="user_id" (click)="setSearchValue('lead_owner')">
                            <input class="mySearchInput" #ownerSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'lead_owner')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="ownerSearch">
                            <mat-option value="">Select BD</mat-option>
                            <mat-option [value]="bd.id" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.user_id.errors" class="invalid-feedback">
                            <div *ngIf="f.user_id.errors.required">BD is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Select Therapists *</label>
                        <mat-select placeholder="Select Therapists" formControlName="doctor_id"
                            (click)="setSearchValue('doctor')">
                            <input class="mySearchInput" #doctorSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'doctor')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="doctorSearch">
                            <mat-option value="">Select Doctor</mat-option>
                            <mat-option [value]="doctor.id" *ngFor="let doctor of doctors">{{doctor.name}}</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.doctor_id.errors" class="invalid-feedback">
                            <div *ngIf="f.doctor_id.errors.required">Therapists is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Body Parts*</label>
                        <mat-select placeholder="Body Parts" formControlName="body_part">
                            <mat-option [value]="1">Underarms</mat-option>
                            <mat-option [value]="2">Face</mat-option>
                            <mat-option [value]="3">Chin</mat-option>
                            <mat-option [value]="4">Upper Lips</mat-option>
                            <mat-option [value]="5">Sidelocks</mat-option>
                            <mat-option [value]="6">Arms</mat-option>
                            <mat-option [value]="7">Legs</mat-option>
                            <mat-option [value]="8">Bikini</mat-option>
                            <mat-option [value]="9">Full Body</mat-option>
                            <mat-option [value]="10">Chest</mat-option>
                            <mat-option [value]="11">Stomach</mat-option>
                            <mat-option [value]="12">Back</mat-option>
                            <mat-option [value]="13">Combo</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.body_part.errors" class="invalid-feedback">
                            <div *ngIf="f.body_part.errors.required">Body part is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5" *ngIf="hairRemovalForm.controls['body_part'].value==13">
                        <label class="form-label">Remarks*</label>
                        <textarea class="form-control" placeholder="Remarks" formControlName="remarks"
                            rows="2"></textarea>
                        <div *ngIf="submitted && f.remarks.errors" class="invalid-feedback">
                            <div *ngIf="f.remarks.errors.required">Remarks is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Package*</label>
                        <mat-select placeholder="Package" formControlName="session">
                            <mat-option value="1 Session">1 Session</mat-option>
                            <mat-option value="3 Session">3 Session</mat-option>
                            <mat-option value="6 Session">6 Session</mat-option>
                            <mat-option value="8 Session">8 Session</mat-option>
                            <mat-option value="11 Session">11 Session</mat-option>
                            <mat-option value="Trial Session">Trial Session</mat-option>
                            <mat-option value="Maintenance Session">Maintenance Session</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.session.errors" class="invalid-feedback">
                            <div *ngIf="f.session.errors.required">Package is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Booking Date*</label>
                        <input type="date" formControlName="booking_date" class="form-control" />
                        <div *ngIf="submitted && f.booking_date.errors" class="invalid-feedback">
                            <div *ngIf="f.booking_date.errors.required">Booking Date is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Time Slots*</label>
                        <mat-select placeholder="Time Slots" formControlName="time_slots">
                            <mat-option value="8AM-10AM">8AM - 10AM</mat-option>
                            <mat-option value="10AM-12AM">10AM - 12AM</mat-option>
                            <mat-option value="12AM-2PM">12AM - 2PM</mat-option>
                            <mat-option value="2PM-4PM">2PM - 4PM</mat-option>
                            <mat-option value="4PM-6PM">4PM - 6PM</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.time_slots.errors" class="invalid-feedback">
                            <div *ngIf="f.time_slots.errors.required">Time Slots is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Address*</label>
                        <textarea class="form-control" placeholder="Address" formControlName="address"
                            rows="2"></textarea>
                        <div *ngIf="submitted && f.address.errors" class="invalid-feedback">
                            <div *ngIf="f.address.errors.required">Address is required</div>
                        </div>
                    </div>
                </div>

                <!-- new -->
                <div class="row">
                <div class="col-sm-12 mt-5">
                    <button type="button" (click)="addMoreSession()" class="btn btn-success pull-left"> Add More Session +</button>
                </div>
                </div>
                <div class="col-sm-12" formArrayName="allSessionDetails" style="display: contents;">
                    <div class="row mt-5"
                        *ngFor="let sessionquantity of allSessionDetails().controls; let i=index"
                        [formGroupName]="i">
                        <div class="col-sm-3 mt-2">
                            <label class="form-label">Session Name*</label>
                            <input type="text" formControlName="session_name" placeholder="Session Name"
                                class="form-control" />
                            <div *ngIf="submitted && sessionquantity.get('session_name').invalid">
                                <div class="invalid-feedback">Session Name is required</div>
                            </div>
                        </div>
                        <div class="col-sm-3 mt-2">
                            <label class="form-label">Date*</label>
                            <input type="datetime-local" formControlName="session_date" class="form-control"/>
                            <div *ngIf="submitted && sessionquantity.get('session_date').invalid">
                                <div class="invalid-feedback">Date is required</div>
                            </div>
                        </div>
                        <div class="col-sm-3 mt-2">
                            <label class="form-label">Status*</label>
                            <mat-select placeholder="Status" formControlName="session_status">
                                <mat-option [value]="1">Postponed</mat-option>
                                <mat-option [value]="2">Canceled</mat-option>
                                <mat-option [value]="3">Completed</mat-option>
                                <mat-option [value]="4">Active</mat-option>
                            </mat-select>
                            <div *ngIf="submitted && sessionquantity.get('session_status').invalid">
                                <div class="invalid-feedback">Status is required</div>
                            </div>
                        </div>
                        <div class="col-sm-3 mt-2">
                            <label class="form-label">&nbsp;</label>
                            <button class="btn btn-danger" mwlConfirmationPopover [popoverTitle]="popoverTitle"
                            [popoverMessage]="popoverMessage" [confirmText]="confirmText" [cancelText]="cancelText"
                            [placement]="placement"
                            (confirm)="removeSession(i, sessionquantity.value.sessionDetailId)"
                            (cancel)="cancelClicked = true" confirmButtonType="danger"
                            cancelButtonType="outline-secondary"
                            (click)="confirmClicked = false; cancelClicked = false" [appendToBody]="true" 
                            *ngIf="i!=0">Remove
                            </button>

                        </div>
                    </div>
                </div>
                <!-- end -->

                <div class="row">
                    <div class="col-sm-12 mt-5">
                        <button type="button" (click)="addMoreReceivedAmount()" class="btn btn-primary pull-left"> Add More
                            Payment Details +</button>
                    </div>
                </div>
                <div class="col-sm-12" formArrayName="receivedAmtResources" style="display: contents;">
                    <div class="row mt-5" *ngFor="let quantity of receivedAmtResources().controls; let i=index"
                        [formGroupName]="i">
                        <div class="col-sm-4 mt-2">
                            <label class="form-label">Payment Mode*</label>
                            <mat-select placeholder="Payment Mode" formControlName="payment_mode">
                                <mat-option [value]="1">Cash</mat-option>
                                <mat-option [value]="2">Emi</mat-option>
                                <mat-option [value]="3">Partial Payment</mat-option>
                            </mat-select>
                            <div *ngIf="submitted && quantity.get('payment_mode').invalid">
                                <div class="invalid-feedback">Payment mode is required</div>
                            </div>
                        </div>
                        <div class="col-sm-4 mt-2">
                            <label class="form-label">Amount*</label>
                            <input type="text" formControlName="partial_amount" placeholder="Partial Amount"
                                class="form-control" />
                            <div *ngIf="submitted && quantity.get('partial_amount').invalid">
                                <div class="invalid-feedback">Amount is required</div>
                            </div>
                        </div>
                        <div class="col-sm-4 mt-2">
                            <label class="form-label">&nbsp;</label>
                            <button class="btn btn-danger" mwlConfirmationPopover [popoverTitle]="popoverTitle"
                                [popoverMessage]="popoverMessage" [confirmText]="confirmText" [cancelText]="cancelText"
                                [placement]="placement"
                                (confirm)="removeQuantity(i, quantity.value.hairRemovalPaymentId)"
                                (cancel)="cancelClicked = true" confirmButtonType="danger"
                                cancelButtonType="outline-secondary"
                                (click)="confirmClicked = false; cancelClicked = false" [appendToBody]="true"
                                *ngIf="i!=0">
                                Remove
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-footer mt-4">
                <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                        class="fa fa-spin fa-spinner"></i> Submit</button>
            </div>
        </form>
    </div>

    <div class="col-sm-4" *ngIf="hairRemovalChk">
        <h2>Upload Documents</h2>
        <div class="form-group">
            <label>Select Document Type</label>
            <mat-select [(ngModel)]="doc_type" placeholder="Select Document Type">
                <mat-option value="">Select Document Type</mat-option>
                <mat-option [value]="1">Consent Form</mat-option>
            </mat-select>
        </div>
        <div class="form-group">
            <label>Upload Documents</label>
            <input [disabled]="uploading" type="file" (change)="selectFile($event)" class="form-control" />
            <span *ngIf="uploading"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
        </div>

        <div class="list-group list-group-flush list-group-hoverable">
            <p *ngIf="fileDeleting"><i class="fa fa-spin fa-spinner"></i> deleting file...</p>
            <div class="list-group-item" *ngFor="let upload of allUploads">
                <div class="row align-items-center">
                    <div class="col text-truncate">
                        <a href="{{s3url}}{{upload.filepath}}" target="_blank" class="text-body d-block">View File</a>
                        <a class="delete-file" style="cursor:pointer" mwlConfirmationPopover
                            [popoverTitle]="popoverTitle" [popoverMessage]="popoverMessage" [confirmText]="confirmText"
                            [cancelText]="cancelText" [placement]="placement" (confirm)="removeFile(upload.id)"
                            (cancel)="cancelClicked = true" confirmButtonType="danger"
                            cancelButtonType="outline-secondary" (click)="confirmClicked = false; cancelClicked = false"
                            [appendToBody]="true"><i class="fa fa-trash"></i></a>

                        <span class="badge badge-danger" *ngIf='upload.upload_type==1'>Consent Form</span>
                        <small class="d-block text-muted text-truncate mt-n1">{{upload.filepath}}</small>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>